import { render, staticRenderFns } from "./DeleteLocationModalContent.vue?vue&type=template&id=0ba6df50"
import script from "./DeleteLocationModalContent.vue?vue&type=script&lang=js"
export * from "./DeleteLocationModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports